import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

const profileIconUrl = "https://cdn-icons-png.flaticon.com/512/9068/9068842.png";
const logoutIconUrl = "https://cdn-icons-png.flaticon.com/512/16787/16787160.png";

export default function ProfileMenu() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    if (!user) return null;

    return (
        <div style={{ position: "relative" }} ref={menuRef}>
            <button
                onClick={() => setShowProfileMenu(!showProfileMenu)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: "#fff",
                    border: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: 24,
                    transition: "all 0.2s",
                    boxShadow: showProfileMenu ? "0 4px 12px rgba(0,0,0,0.12)" : "0 2px 8px rgba(0,0,0,0.08)",
                }}
                onMouseEnter={e => !showProfileMenu && (e.currentTarget.style.background = "#f8f9ff")}
                onMouseLeave={e => !showProfileMenu && (e.currentTarget.style.background = "#fff")}
            >
                <img
                    src={profileIconUrl}
                    alt="Profile"
                    style={{ width: 32, height: 32, borderRadius: "50%" }}
                />
                <span style={{ fontWeight: 600, color: "#172d44", fontSize: 14 }}>
                    {user?.name || user?.email?.split("@")[0] || "User"}
                </span>
                <span style={{ fontSize: 10, color: "#667699", transform: showProfileMenu ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▼</span>
            </button>

            {showProfileMenu && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        width: 240,
                        background: "#fff",
                        borderRadius: 12,
                        boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                        border: "1px solid #e2e8f0",
                        padding: 8,
                        marginTop: 12,
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            padding: "12px 16px",
                            fontSize: 14,
                            color: "#64748b",
                            borderBottom: "1px solid #f1f5f9",
                            wordBreak: "break-all",
                            fontWeight: 500
                        }}
                    >
                        {user?.email || "No email"}
                    </div>

                    <button
                        onClick={handleLogout}
                        style={{
                            width: "100%",
                            padding: "12px 16px",
                            background: "none",
                            border: "none",
                            textAlign: "left",
                            fontSize: 15,
                            color: "#dc2626",
                            fontWeight: 700,
                            cursor: "pointer",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            marginTop: 4,
                            transition: "background 0.2s",
                        }}
                        onMouseOver={e => (e.currentTarget.style.background = "#fef2f2")}
                        onMouseLeave={e => (e.currentTarget.style.background = "none")}
                    >
                        <img src={logoutIconUrl} alt="Logout" style={{ width: 22, height: 22 }} />
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
}
